import {UIGameCardController} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardController'
import {UIGameCardWithRatioContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardWithRatioContainerView'
import {PIXI} from '@colonist/pixi'
import {StorageWrapper} from '../../../../shared/scripts/StorageWrapper'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIMGameCardController extends UIGameCardController {
    protected getCardContainerView(): UIGameCardWithRatioContainerView {
        const canvas = this.uiGameManager.canvasController
        const h = canvas.itemSize * 1.2
        const w = canvas.appW
        const x = 0
        const y = canvas.appH - h

        const cardContainerView = new UIGameCardWithRatioContainerView(this.uiGameManager, x, y, w, h, canvas.app.stage, true)
        cardContainerView.drawBg(0x000000, 0.2)
        this.createSpaceForBottomSafeArea(cardContainerView)
        return cardContainerView
    }

    private createSpaceForBottomSafeArea(cardContainerView: UIGameCardWithRatioContainerView) {
        if(UIUtilsEjsVariables.isUserOnTabletApp) return
        const canvas = this.uiGameManager.canvasController
        const safeAreaHeight = (StorageWrapper.getSafeAreaInsetBottom() ?? 0) * 0.5
        const safeArea = new PIXI.Graphics()
        safeArea.beginFill(0x000000, 0.2)
        safeArea.drawRect(0, cardContainerView.height, canvas.appW, safeAreaHeight)
        safeArea.endFill()
        cardContainerView.addChild(safeArea)
        cardContainerView.y -= safeAreaHeight
    }
}
